/**
 * The phone app's words for a document's actions (piece 35, *The fourth release*,
 * *Document actions*; decisions 4641, 4740), spread into the one string lookup
 * beside the earlier batches' words. Every act's own label, window title, field,
 * hint and done sentence is read from the web's own key, such as Send, Mark as
 * Accepted, Convert to Sales Order, Release, Raise a work order, Put On Hold or
 * Approve, and is not repeated here. These are the heading over the acts and the
 * sentence naming what each kind leaves to the web.
 */
export const DOCUMENT_ACTION_STRINGS = {
  'mobile.documentActions.title': 'Actions',
  'mobile.documentActions.sureBody': 'Press {act} to go ahead on {number}, or Cancel.',
  'mobile.documentActions.unsent': 'The server did not answer, so this may not have gone through. The document is being read again; read it before pressing anything twice.',
  'mobile.documentActions.onWeb.quote': 'Editing the quote, Duplicate, Record Signed Copy, its files and its notes stay on the web.',
  'mobile.documentActions.onWeb.salesOrder': 'Editing the order, Raise an Invoice, Raise a Purchase Order, Waive Customer PO, change orders, packages and shipments stay on the web.',
  'mobile.documentActions.onWeb.workOrder': 'Schedule, Reschedule, Create Follow-Up, Raise an Invoice, the priority and the job’s lines stay on the web.',
} as const;
